// extracted by mini-css-extract-plugin
export default {"title":"pageTitle_title__TKMoz"};